/**
 * Post-processes htmldiff-js output for consolidation amendment review:
 * keeps the full inline track-changes view — green insertions
 * (`ins.diffins` / `ins.diffmod`) and red strikethrough deletions
 * (`del.diffdel` / `del.diffmod`) — so removed ("udgår") text stays visible.
 * Only strips empty `<ins>` / `<del>` nodes that htmldiff-js can emit.
 */
export const toAmendmentReviewDiffHtml = (diffHtml: string): string => {
  if (!diffHtml.trim()) return diffHtml;

  const doc = new DOMParser().parseFromString(
    `<div id="diff-root">${diffHtml}</div>`,
    "text/html"
  );
  const root = doc.getElementById("diff-root");
  if (!root) return diffHtml;

  root.querySelectorAll("ins, del").forEach((el) => {
    if (!el.textContent?.trim() && el.children.length === 0) {
      el.remove();
    }
  });

  return root.innerHTML;
};
